import React from 'react';
import { motion } from 'framer-motion';
import { Crown, GlassWater, Plane, Star } from 'lucide-react';
const services = [{
  icon: <Crown className="w-8 h-8" data-id="element-144" />,
  title: 'VIP私人伴游',
  description: '为您量身定制的专属陪伴，无论是商务晚宴还是私人聚会，展现您的非凡品味。',
  delay: 0.2
}, {
  icon: <GlassWater className="w-8 h-8" data-id="element-145" />,
  title: '社交场合陪伴',
  description: '优雅大方的社交伴侣，助您在各类社交场合游刃有余，成为全场焦点。',
  delay: 0.3
}, {
  icon: <Plane className="w-8 h-8" data-id="element-146" />,
  title: '商务旅行伴侣',
  description: '专业的商务旅行助理与伴游，让您的差旅时光充满温馨与惬意。',
  delay: 0.4
}, {
  icon: <Star className="w-8 h-8" data-id="element-147" />,
  title: '定制专属体验',
  description: '根据您的具体需求，打造独一无二的私密约会行程，满足您的所有期待。',
  delay: 0.5
}];
export function ServicesSection() {
  return <section className="py-24 bg-dark-bg relative overflow-hidden" data-id="element-148">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-149">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px]" data-id="element-150" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-purple-900/5 rounded-full blur-[100px]" data-id="element-151" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-serif text-3xl md:text-5xl text-white mb-4" data-id="element-154">
            我们的服务
          </motion.h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 100
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="h-1 bg-gold-500 mx-auto" data-id="element-155" />
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mt-6 text-gray-400 max-w-2xl mx-auto" data-id="element-156">
            SGLonelyGuy
            致力于为您提供最高品质的伴游服务，每一项服务都经过精心设计，只为满足最挑剔的您。
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-157">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: service.delay
        }} whileHover={{
          y: -10
        }} className="group relative p-8 bg-dark-card border border-dark-border rounded-lg hover:border-gold-500/30 transition-all duration-300" data-id="element-158">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg" data-id="element-159" />

              <div className="relative z-10" data-id="element-160">
                <div className="w-16 h-16 rounded-full bg-dark-surface border border-gold-500/20 flex items-center justify-center text-gold-500 mb-6 group-hover:scale-110 group-hover:border-gold-500 transition-all duration-300 shadow-[0_0_15px_rgba(212,175,55,0.1)]" data-id="element-161">
                  {service.icon}
                </div>

                <h3 className="text-xl font-serif text-white mb-3 group-hover:text-gold-400 transition-colors" data-id="element-162">
                  {service.title}
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed group-hover:text-gray-300 transition-colors" data-id="element-163">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}